import gql from 'graphql-tag';

export default gql`
 query getUniversalNav {
  getUniversalNav {
    headerProperty {
      evergreenMessage
      logoImage
      linkText
      linkHref
      searchPageUrl
    }
    menuNavigation {
      title
      url
      disclaimer
      children {
        carouselItems {
          image
          imageAltText
          title
          url
        }
        label
        columnType
        titleColor
        shopAllText
        shopAllUrl
        links {
          title
          url
          promoMessage
          titleColor
        }
      }
    }
    navigationGlobalControls {
      promoColorCode
      hideShopAllLinks
    }
  }
}
`;
